import { getDeviceId } from '$lib/utils/device-id';
import { LOCAL_STORAGE_KEYS, QUERY_PARAM_KEYS } from '$lib/utils/constants';

/**
 * Returns analytics identifiers from localStorage, defaulting to undefined if absent.
 * @returns {{
 *   adid: string|undefined,
 *   android_id: string|undefined,
 *   app_instance_id: string|undefined,
 *   app_token: string|undefined,
 *   device_id: string|undefined,
 *   gps_adid: string|undefined,
 *   idfa: string|undefined,
 *   idfv: string|undefined,
 *   udid: string|undefined,
 * }}
 */
export function getAnalyticsIdentifiers() {
	return {
		adid: localStorage.getItem(LOCAL_STORAGE_KEYS.ADID) ?? undefined,
		android_id: localStorage.getItem(LOCAL_STORAGE_KEYS.ANDROID_ID) ?? undefined,
		app_instance_id: localStorage.getItem(LOCAL_STORAGE_KEYS.APP_INSTANCE_ID) ?? undefined,
		app_token: localStorage.getItem(LOCAL_STORAGE_KEYS.APP_TOKEN) ?? undefined,
		device_id: getDeviceId() ?? undefined,
		gps_adid: localStorage.getItem(LOCAL_STORAGE_KEYS.GPS_ADID) ?? undefined,
		idfa: localStorage.getItem(LOCAL_STORAGE_KEYS.IDFA) ?? undefined,
		idfv: localStorage.getItem(LOCAL_STORAGE_KEYS.IDFV) ?? undefined,
		udid: localStorage.getItem(LOCAL_STORAGE_KEYS.UDID) ?? undefined,
	};
}

/**
 * Persists supported analytics identifiers from query params to localStorage (if present).
 */
export function setAllAnalyticsIdentifiersFromQuery() {
	try {
		const searchParams = new URLSearchParams(location.search);
		const keyMap = [
			[QUERY_PARAM_KEYS.ADID, LOCAL_STORAGE_KEYS.ADID],
			[QUERY_PARAM_KEYS.ANDROID_ID, LOCAL_STORAGE_KEYS.ANDROID_ID],
			[QUERY_PARAM_KEYS.APP_INSTANCE_ID, LOCAL_STORAGE_KEYS.APP_INSTANCE_ID],
			[QUERY_PARAM_KEYS.APP_TOKEN, LOCAL_STORAGE_KEYS.APP_TOKEN],
			[QUERY_PARAM_KEYS.GPS_ADID, LOCAL_STORAGE_KEYS.GPS_ADID],
			[QUERY_PARAM_KEYS.IDFA, LOCAL_STORAGE_KEYS.IDFA],
			[QUERY_PARAM_KEYS.IDFV, LOCAL_STORAGE_KEYS.IDFV],
			[QUERY_PARAM_KEYS.UDID, LOCAL_STORAGE_KEYS.UDID],
		];
		for (const [queryKey, storageKey] of keyMap) {
			const value = searchParams.get(queryKey);
			if (value) {
				localStorage.setItem(storageKey, value);
			}
		}
	} catch (e) {
		console.error('Error setting all analytics identifiers from query', e);
	}
}
